import React from 'react';
import { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';

const talentMatchingQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute,
      refetchOnWindowFocus: false,
    },
  },
});

const TalentMatchingQueryClientProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <QueryClientProvider client={talentMatchingQueryClient}>
      {children}
    </QueryClientProvider>
  );
};

export default TalentMatchingQueryClientProvider;
